import { render, staticRenderFns } from "./addDataMigration.vue?vue&type=template&id=52fcfc39&scoped=true&"
import script from "./addDataMigration.vue?vue&type=script&lang=js&"
export * from "./addDataMigration.vue?vue&type=script&lang=js&"
import style0 from "./addDataMigration.vue?vue&type=style&index=0&id=52fcfc39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fcfc39",
  null
  
)

export default component.exports